import React from 'react';
import { TableCell, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Trash2Icon } from 'lucide-react';

interface RateRowProps {
  rate: {
    roomTypeId: number;
    bathroomTypeId: number;
    categoryId: number;
    currencyId: number;
    price: number;
  };
  index: number;
  readOnly: boolean;
  roomTypes: Array<{ id: number; name: string }>;
  bathroomTypes: Array<{ id: number; name: string }>;
  roomCategories: Array<{ id: number; name: string }>;
  currencyTypes: Array<{ id: number; name: string }>;
  onRateChange: (index: number, field: string, value: number) => void;
  onDelete: (index: number) => void;
}

export const RateRow = ({
  rate,
  index,
  readOnly,
  roomTypes,
  bathroomTypes,
  roomCategories,
  currencyTypes,
  onRateChange,
  onDelete
}: RateRowProps) => {
  return (
    <TableRow>
      <TableCell className="w-1/4">
        <Select
          value={String(rate.roomTypeId)}
          onValueChange={(value) => onRateChange(index, 'roomTypeId', Number(value))}
          disabled={readOnly}
        >
          <SelectTrigger className="w-full min-w-[200px]">
            <SelectValue placeholder="Seleccionar tipo" />
          </SelectTrigger>
          <SelectContent>
            {roomTypes.map((type) => (
              <SelectItem key={type.id} value={String(type.id)}>
                {type.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </TableCell>
      <TableCell className="w-32">
        <Select
          value={String(rate.bathroomTypeId)}
          onValueChange={(value) => onRateChange(index, 'bathroomTypeId', Number(value))}
          disabled={readOnly}
        >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Seleccionar baño" />
          </SelectTrigger>
          <SelectContent>
            {bathroomTypes.map((type) => (
              <SelectItem key={type.id} value={String(type.id)}>
                {type.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </TableCell>
      <TableCell className="w-32">
        <Select
          value={String(rate.categoryId)}
          onValueChange={(value) => onRateChange(index, 'categoryId', Number(value))}
          disabled={readOnly}
        >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Seleccionar categoría" />
          </SelectTrigger>
          <SelectContent>
            {roomCategories.map((category) => (
              <SelectItem key={category.id} value={String(category.id)}>
                {category.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </TableCell>
      <TableCell className="w-24">
        <Select
          value={String(rate.currencyId)}
          onValueChange={(value) => onRateChange(index, 'currencyId', Number(value))}
          disabled={readOnly}
        >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Seleccionar moneda" />
          </SelectTrigger>
          <SelectContent>
            {currencyTypes.map((currency) => (
              <SelectItem key={currency.id} value={String(currency.id)}>
                {currency.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </TableCell>
      <TableCell>
        <div className="flex items-center gap-2">
          <Input
            type="number"
            min="0"
            step="0.01"
            value={rate.price || ''}
            onChange={(e) => {
              const value = e.target.value === '' ? 0 : parseFloat(e.target.value);
              onRateChange(index, 'price', value);
            }}
            disabled={readOnly}
            className="w-32"
            placeholder="0.00"
          />
        </div>
      </TableCell>
      <TableCell>
        <Button
          variant="outline"
          size="sm"
          className="w-28 bg-red-500 text-white hover:bg-red-600"
          onClick={() => onDelete(index)}
          disabled={readOnly}
        >
          <Trash2Icon className="h-4 w-4 mr-1" />
          Eliminar
        </Button>
      </TableCell>
    </TableRow>
  );
}; 